/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    EmailLinkMethodOptions,
    instanceOfEmailLinkMethodOptions,
    EmailLinkMethodOptionsFromJSON,
    EmailLinkMethodOptionsFromJSONTyped,
    EmailLinkMethodOptionsToJSON,
} from './EmailLinkMethodOptions';
import {
    OIDCMethodOptions,
    instanceOfOIDCMethodOptions,
    OIDCMethodOptionsFromJSON,
    OIDCMethodOptionsFromJSONTyped,
    OIDCMethodOptionsToJSON,
} from './OIDCMethodOptions';
import {
    OTPViaEmailMethodOptions,
    instanceOfOTPViaEmailMethodOptions,
    OTPViaEmailMethodOptionsFromJSON,
    OTPViaEmailMethodOptionsFromJSONTyped,
    OTPViaEmailMethodOptionsToJSON,
} from './OTPViaEmailMethodOptions';
import {
    OTPViaSMSMethodOptions,
    instanceOfOTPViaSMSMethodOptions,
    OTPViaSMSMethodOptionsFromJSON,
    OTPViaSMSMethodOptionsFromJSONTyped,
    OTPViaSMSMethodOptionsToJSON,
} from './OTPViaSMSMethodOptions';
import {
    PasswordMethodOptions,
    instanceOfPasswordMethodOptions,
    PasswordMethodOptionsFromJSON,
    PasswordMethodOptionsFromJSONTyped,
    PasswordMethodOptionsToJSON,
} from './PasswordMethodOptions';
import {
    SAMLMethodOptions,
    instanceOfSAMLMethodOptions,
    SAMLMethodOptionsFromJSON,
    SAMLMethodOptionsFromJSONTyped,
    SAMLMethodOptionsToJSON,
} from './SAMLMethodOptions';
import {
    SMSLinkMethodOptions,
    instanceOfSMSLinkMethodOptions,
    SMSLinkMethodOptionsFromJSON,
    SMSLinkMethodOptionsFromJSONTyped,
    SMSLinkMethodOptionsToJSON,
} from './SMSLinkMethodOptions';
import {
    TOTPMethodOptions,
    instanceOfTOTPMethodOptions,
    TOTPMethodOptionsFromJSON,
    TOTPMethodOptionsFromJSONTyped,
    TOTPMethodOptionsToJSON,
} from './TOTPMethodOptions';
import {
    WebAuthnMethodOptions,
    instanceOfWebAuthnMethodOptions,
    WebAuthnMethodOptionsFromJSON,
    WebAuthnMethodOptionsFromJSONTyped,
    WebAuthnMethodOptionsToJSON,
} from './WebAuthnMethodOptions';

/**
 * @type FactorOptions
 * 
 * @export
 */
export type FactorOptions = { method: 'email_link' } & EmailLinkMethodOptions | { method: 'oidc' } & OIDCMethodOptions | { method: 'otp_via_email' } & OTPViaEmailMethodOptions | { method: 'otp_via_sms' } & OTPViaSMSMethodOptions | { method: 'password' } & PasswordMethodOptions | { method: 'saml' } & SAMLMethodOptions | { method: 'sms_link' } & SMSLinkMethodOptions | { method: 'totp' } & TOTPMethodOptions | { method: 'webauthn' } & WebAuthnMethodOptions;

export function FactorOptionsFromJSON(json: any): FactorOptions {
    return FactorOptionsFromJSONTyped(json, false);
}

export function FactorOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FactorOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['method']) {
        case 'email_link':
            return {...EmailLinkMethodOptionsFromJSONTyped(json, true), method: 'email_link'};
        case 'oidc':
            return {...OIDCMethodOptionsFromJSONTyped(json, true), method: 'oidc'};
        case 'otp_via_email':
            return {...OTPViaEmailMethodOptionsFromJSONTyped(json, true), method: 'otp_via_email'};
        case 'otp_via_sms':
            return {...OTPViaSMSMethodOptionsFromJSONTyped(json, true), method: 'otp_via_sms'};
        case 'password':
            return {...PasswordMethodOptionsFromJSONTyped(json, true), method: 'password'};
        case 'saml':
            return {...SAMLMethodOptionsFromJSONTyped(json, true), method: 'saml'};
        case 'sms_link':
            return {...SMSLinkMethodOptionsFromJSONTyped(json, true), method: 'sms_link'};
        case 'totp':
            return {...TOTPMethodOptionsFromJSONTyped(json, true), method: 'totp'};
        case 'webauthn':
            return {...WebAuthnMethodOptionsFromJSONTyped(json, true), method: 'webauthn'};
        default:
            throw new Error(`No variant of FactorOptions exists with 'method=${json['method']}'`);
    }
}

export function FactorOptionsToJSON(value?: FactorOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['method']) {
        case 'email_link':
            return EmailLinkMethodOptionsToJSON(value);
        case 'oidc':
            return OIDCMethodOptionsToJSON(value);
        case 'otp_via_email':
            return OTPViaEmailMethodOptionsToJSON(value);
        case 'otp_via_sms':
            return OTPViaSMSMethodOptionsToJSON(value);
        case 'password':
            return PasswordMethodOptionsToJSON(value);
        case 'saml':
            return SAMLMethodOptionsToJSON(value);
        case 'sms_link':
            return SMSLinkMethodOptionsToJSON(value);
        case 'totp':
            return TOTPMethodOptionsToJSON(value);
        case 'webauthn':
            return WebAuthnMethodOptionsToJSON(value);
        default:
            throw new Error(`No variant of FactorOptions exists with 'method=${value['method']}'`);
    }

}

